import { render, staticRenderFns } from "./updateMedicl.vue?vue&type=template&id=c2ea5bc2&"
import script from "./updateMedicl.vue?vue&type=script&lang=js&"
export * from "./updateMedicl.vue?vue&type=script&lang=js&"
import style0 from "./updateMedicl.vue?vue&type=style&index=0&id=c2ea5bc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports